export enum AppCodeGroup {
    Buttons = 1,
    Steps =2,
    Tabs = 3
}
